export default __webpack_public_path__ + "static/media/IMG_6937.02bc7de6.jpg";